import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("a", {
    href: $props.link,
    class: "gfu-btn gfu-btn--circle gfu-btn--search-primary _flexinline _jc-c _ai-c _bxsh--base",
    target: "_blank",
    rel: "noopener noreferrer"
  }, [
    _createVNode(_component_base_icon, {
      name: "help-icon",
      "icon-namespace": "ga",
      class: "_tc--accent"
    })
  ], 8 /* PROPS */, _hoisted_1))
}